export const baseUrl =
    process.env.NODE_ENV === 'development'
        ? 'http://localhost'
        : window.location.protocol + '//' + window.location.host

export const cpsUrl =
    process.env.NODE_ENV === 'development'
        ? 'http://localhost'
        : window.location.protocol + '//' + window.location.host
